import http from '../../axios';

export const fetchBibsRacesList = async () => http.get('/bibs/races', {});

export const fetchBibsRacesSearch = async search =>
  http.get('/bibs/search', {
    params: {
      search,
    },
  });

export const fetchBibsDashboard = async raceID =>
  http.get('/bibs/races/dashboard', {
    params: {
      raceID,
    },
  });

export const fetchBibsList = async (raceID, event, page) =>
  http.get('/bibs/list', {
    params: {
      raceID,
      event,
      page,
    },
  });

export const fetchBibsSearch = async (raceID, event, search) =>
  http.get('/bibs/search', {
    params: {
      raceID,
      event,
      search,
    },
  });

export const fetchBibsDetails = async (raceID, event, bibNo, name) =>
  http.get('/bibs/details', {
    params: {
      raceID,
      event,
      bibNo,
      name,
    },
  });

export const updateBibsCollection = async (id, collectionData) =>
  http.put('/bibs/collection', {
    id,
    ...collectionData,
  });

export const downloadBibs = async (raceID, event) =>
  http.post(
    '/bibs/download',
    {
      raceID,
      event,
    },
    {
      responseType: 'blob',
    },
  );
